import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

/**
 * How many copies of each receipt to print. A stepper rather than a select because this runs
 * on touch terminals, where two big targets beat a dropdown.
 */
export default function CopiesStepper({ value, min = 1, max = 4, onChange }) {
  const { t } = useTranslation(null, { keyPrefix: 'Views:PrinterSettings:PrinterSettingsView' });

  const copies = Number(value) || min;

  return (
    <div
      role="group"
      aria-label={t('form.print_copies.label')}
      className="flex items-center rounded-lg border border-gray-200"
    >
      <Button
        type="text"
        aria-label={t('form.print_copies.decrease')}
        icon={<MinusOutlined />}
        disabled={copies <= min}
        onClick={() => onChange(copies - 1)}
        className="!h-11 !w-11"
      />
      <span aria-live="polite" className="min-w-11 text-center font-medium tabular-nums">
        {copies}
      </span>
      <Button
        type="text"
        aria-label={t('form.print_copies.increase')}
        icon={<PlusOutlined />}
        disabled={copies >= max}
        onClick={() => onChange(copies + 1)}
        className="!h-11 !w-11"
      />
    </div>
  );
}
